module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_35.7cfe6c0f.png";